<script>
    export let icons;
    export let selected;

    import SelectionTitle from './SelectionTitle.svelte';

    import _ from 'lodash';

    const selectionClick = (option) => {
        selected = option;
    };
</script>

<div class="icon-selection">
    {#each icons as icon}
        <div
            class={`icon-selection__option${icon.title === selected.title ? ' selected' : ''}`}
            on:click={() => selectionClick(icon)}
        >
            <SelectionTitle title={icon.title} style="text-align: center; width: 70px;"/> 
            <img
                src={`${icon.title === selected.title ? icon.selected_img : icon.unselected_img}`}
                alt={icon.alt}
            />
        </div>
    {/each}
</div>

<style>
    .icon-selection {
        --width_of_icon: 50px;

        display: flex;
        flex-direction: row;
        align-items: flex-end;
        width: calc(var(--width_of_icon) * 2)
    }
    .icon-selection__option {
        display: flex;
        flex-direction: column;
        align-items: center;

        width: var(--width_of_icon);
    }
    .icon-selection__option:not(.selected) img {
        cursor: pointer;
    }
</style>